import React from "react";
import { Accordion, Button, Card, Col, Container, Dropdown, Form, Modal, OverlayTrigger, Row, Tooltip } from "react-bootstrap";
import { Utils } from "../../Common/Utilis";
import moment from "moment";
import { toast, ToastContainer } from "react-toastify";
import Joi from "joi-browser";
import { DropDownList } from "../Reports/common-components/dropdown-list";
import DropdownToggle from "react-bootstrap/esm/DropdownToggle";
import { StaticArrays } from "../../Common/StaticArrays";
import _ from "lodash";
import OutsideClickHandler from "react-outside-click-handler";
import { FiChevronDown } from "react-icons/fi";
import Calendar from 'react-calendar';
import EllipsisWithTooltip from "react-ellipsis-with-tooltip";
import BootstrapTable from "react-bootstrap-table-next";
import ToolkitProvider from "react-bootstrap-table2-toolkit/dist/react-bootstrap-table2-toolkit";
import { AddProcedure } from "./AddProcedure";
import { LocationAdded } from "./LocationAdded";
import { MaintenanceLocationSlideOut } from "./MaintenanceLocationSlideOut";
import { ProcedureMaintenanceSlideOut } from "./ProcedureMaintenanceSlideOut";
import { IFacilityMaintenanceListRequest, IGetProceureDetailsRequestDto } from "../../Common/Contracts/IMaintenanceSchedule";
import { FacilityMaintenance } from "../../Common/Services/FacilityMaintenance";
import { AnyARecord } from "dns";
import { confirmAlert } from "react-confirm-alert";
import { resolve, reject } from "q";
import { SingleSearchDropdownList } from "../../Common/Components/SingleSearchDropdownList";
import DropdownMenu from "react-bootstrap/esm/DropdownMenu";
import { IWorkOrderRequestDto } from "../../Common/Contracts/IWorkOrder";
import { WorkOrder } from "../../Common/Services/WorkOrder";
export class MaintenanceSchudleSlieOut extends React.Component<any, any> {
  private refMaintenanceLocationSlideOut: any; 
  private refAddProcedure: any; 
  private refLocationAdded: any; 
  private FormSchema = Joi.object({
      frequencyCustomValue: Joi.number()
        .required()
        .error((errors) => {
          return errors.map((error) => {
            return { message: "Please enter a Frequency" };
          });
        }),
      description: Joi.string().max(200)
      .required()
      .error((errors) => {
        return errors.map((error) => {
          return { message: "Please enter a Description" };
        });
      })
      // .optional().allow('')
    });
  constructor(props: any) {
    super(props);
    this.refMaintenanceLocationSlideOut = React.createRef();
    this.refAddProcedure = React.createRef();
    this.refLocationAdded = React.createRef();   
    this.state = {


      tableProceuresData: [],     
      proceduresList: [],
      scheduleData: this.props.parentState.manageParentRowData,
      // locationData:this.props.parentState.locationData,
      hidValue: this.props.parentState.hidValue,
      hotelName: this.props.parentState.hotelName,
      isCountLocation: 0,
      tableLocationData: [],
      isProcedureMaintenanceSlideout: false,
      isChanges: false,
      temptableProceuresData: [],     
      tempTableproceduresList: [],
      isProcedureRow: [],
      priorities: this.props.parentState.prioritiList,
      priority: "",
      isProcedureChanges:false,
      isRefresh:false,
      isNew:true,
      name:this.props.parentState.manageParentRowData[0]?.name,
      description : this.props.parentState.manageParentRowData[0]?.description,
      startDate:this.props.parentState.manageParentRowData[0]?.startDate,
      endDate:this.props.parentState.manageParentRowData[0]?.endDate,
      frequencyValue:this.props.parentState.manageParentRowData[0]?.frequencyValue,
      frequencyCustom:this.props.parentState.manageParentRowData[0]?.frequencyCustom,
      // frequency:this.props.parentState.manageParentRowData[0]?.frequencyOrginalValue,
      calendarOpened: false,
      endCalendarOpened: false,
      dueDatecalendarOpened: false,
      freequencyList: [{ id: 1, name: "Days" }, { id: 2, name: "Weeks" }, { id: 3, name: "Months" }, { id: 4, name: "Years" }],
      mainFrequencyList: [{ id: 1, name: "Daily" }, { id: 2, name: "Weekly" }, { id: 3, name: "Monthly" }, { id: 5, name: "Quarterly" } ,{ id: 4, name: "Yearly" },{ id: 6, name: "Custom" }],
      frequencyCustomValue: this.props.parentState.manageParentRowData[0]?.frequenId,
      customFrequenId: (this.state?.freequencyList?.find((item) => item.name.toLowerCase() === this.props.parentState.manageParentRowData[0]?.frequencyOrginalValue?.toLowerCase())?.id || 0),
      mainFrequenId: (this.state?.mainFrequencyList?.find((item) => item.name.toLowerCase() === this.props.parentState.manageParentRowData[0]?.frequencyOrginalValue?.toLowerCase())?.id || 0),
      showCustomdropdown:false,
      errors: {},
      inputPosition: 0,
      zeroValidation:false,
      assignToList: [],
      assignedTo:this.props.parentState.manageParentRowData[0]?.assignedTo,
      status:this.props.parentState.manageParentRowData[0]?.status,
      // activeKeys: ["0", "1"],
      proceduresListCount:0,
      locationControl:[],
      showProcedures: true,
      showLocations: true,
      currentDate: "",
      isScheduleExistsShow:this.props.parentState.tableData.some((item) => item.maintenanceScheduleId === this.props.parentState.manageParentRowData[0]?.id)
      // procedures: [{ name: 'Procedure A' }, { name: 'Procedure B' }],
    };
  }

  componentDidMount() {
    this.GetMSProceureDetails();
    this.GetAllMLocationDetails();
    this.setState({showCustomdropdown:this.props.parentState.manageParentRowData[0]?.frequencyCustom ? true : false})
    this.getAssignUserList();
    let todayDate: any = new Date(); 
    todayDate.setDate(todayDate.getDate() + 1) 
    this.setState({ currentDate: todayDate })
    // this.GetMSAllProceureDetails();
    // this.setState({isChanges:this.state.scheduleData[0]?.isChanges});
    // this.setState({isNew:this.state.scheduleData[0]?.isNew,priority:this.state.scheduleData[0]?.priority});

  }
getAssignUserList() {
    let request = {} as IWorkOrderRequestDto;
    request.hotelID = Number(this.props.parentState.hidValue);
    request.type = "PreventativeAssignedTo";
    WorkOrder.GetFcUserDetailsList(request)
      .then(async (result: any | null) => {
        // debugger
        if (result != null && result.length > 0) {
          let Data = result.map((x) => {
            return { id: x?.user_UniqueID, name: x?.employee };
          });

          this.setState({ assignToList: Data }, () => {
            this.setState({
              assignToList: [{ id: -1, name: "Select a technician" }, ...Data],
            });
          });
        } else {
          this.setState({
            assignToList: [{ id: -1, name: "All" }],
          });
        }
        resolve();
      })
      .catch((err) => {
        Utils.toastError(`Server Error, ${err}`, {});

        reject();
      });
  }
  GetMSProceureDetails() {
    this.setState({ isworkLoader: true });
    let request = {} as IGetProceureDetailsRequestDto;
    request.hotelid = Number(this.props.parentState.hidValue);
    request.gblId = this.state.scheduleData[0]?.id;
    let storage = JSON.parse(localStorage.getItem("storage")!);   
    let userUniqueID = storage === null ? 0 : (storage.user_UniqueID as any);   
   request.loginUser = Number(userUniqueID);

    // debugger
    FacilityMaintenance.GetMSProceureDetails(request)
      .then(async (result: any | null) => {
          // debugger;
        if (result != null && result.length > 0) {
          this.setState({ tableProceuresData: result,temptableProceuresData:result,proceduresListCount:result.length },()=>{
            // if (this.refAddProcedure.current !== null){            
            //   this.refAddProcedure.current.upatedProcedureList(this.state.tableProceuresData);
            // }
          });
        } else {
          this.setState({ tableProceuresData: [],temptableProceuresData:[] },()=>{
            // if (this.refAddProcedure.current !== null){           
            //   this.refAddProcedure.current.upatedProcedureList(this.state.tableProceuresData);
            // }
          });
        }


        resolve();
      })
      .catch((err) => {

        Utils.toastError(`Server Error, ${err}`, {
          position: toast.POSITION.BOTTOM_RIGHT,
          containerId: "MaintenceShudleSldieOut",
        });

         reject();
      });
  }



 GetAllMLocationDetails() {
    // this.setState({ isworkLoader: true });
    // debugger
    this.setState({ isworkLoader: true });
    let request = {} as IGetProceureDetailsRequestDto;
    request.hotelid = Number(this.props.parentState.hidValue);
    request.type = "GetLocationPMs";
    request.gblId = this.state.scheduleData[0]?.id;
    let storage = JSON.parse(localStorage.getItem("storage")!);   
    let userUniqueID = storage === null ? 0 : (storage.user_UniqueID as any);   
   request.loginUser = Number(userUniqueID);
    //  debugger

    FacilityMaintenance.GetAllMLocationDetails(request)
      .then(async (result: any | null) => {
      // debugger
        if (result != null && result.length > 0) {
          
        this.setState({locationControl:result});
        } else {
          this.setState({locationControl:[]});
        }   


        resolve();
      })
      .catch((err) => {
      
        Utils.toastError(`Server Error, ${err}`, {
          position: toast.POSITION.BOTTOM_RIGHT,
          containerId: "LocationShudleSldieOut",
        });

        reject();
      });
  }



  closeWorkSlideOut = () => {
    if(this.state.isChanges){
      this.hideApprovalModal("sideClick");
    }else{
      this.props?.closeWorkSlideOut();
    }
    
   // this.props?.closeWorkSlideOut();
  }

  procedureSelection = (item: any, Type: any) => {
        // debugger;
        //let tblPDate= _.cloneDeep([...this.state.tableProceuresData]); 
    let astname="";
    if (Type === "add") {
       let data = item;
      let tableProceuresdata= _.cloneDeep([...this.state.tableProceuresData]); 
      let tableProceuresTempdata: any = [];
      data.forEach(element => {

        if (element.isChecked == "yes") {
          let tempData: any = {};
          let name=element.assetName.split(':')
        if(name.length>0){
          astname=name[1];
        }
          tempData.assetName =  astname;
          tempData.assetTypeId = element.assetTypeId;
          tempData.countTask = element.countTask;
          tempData.hid = element.hid;
          tempData.id = element.id;
          tempData.isChecked = element.isChecked;
          tempData.isGlobal = element.isGlobal;
          tempData.procedureId = element.procedureId;
          tempData.procedureName = element.procedureName;
          tableProceuresTempdata.push(tempData);
        }
      });


      // let tempData: any = {};
      // let element = item;

      //   if (element.isChecked == "yes") {
         
      //     let name=element.assetName.split(':')
      //   if(name.length>0){
      //     astname=name[1];
      //   }
      //     tempData.assetName =  astname;
      //     tempData.assetTypeId = element.assetTypeId;
      //     tempData.countTask = element.countTask;
      //     tempData.hid = element.hid;
      //     tempData.id = element.id;
      //     tempData.isChecked = element.isChecked;
      //     tempData.isGlobal = element.isGlobal;
      //     tempData.procedureId = element.procedureId;
      //     tempData.procedureName = element.procedureName;
      //     //tableProceuresTempdata.push(tempData);
      //   }
      







      // const index = data.findIndex((xvalue) => xvalue.id === item);
     // tblPDate.push(tempData);
      // this.setState({ tableProceuresData: tblPDate, isChanges: true},()=>{
      //   if (this.refAddProcedure.current !== null){
      //     this.refAddProcedure.current.upatedProcedureList(this.state.tableProceuresData);
      //   }
        
      // });
      this.setState({tableProceuresData:[]},()=>{
        this.setState({ tableProceuresData: tableProceuresTempdata, isChanges: true,isNew:false},()=>{
        //      if (this.refAddProcedure.current !== null){
        //   this.refAddProcedure.current.upatedProcedureList(this.state.tableProceuresData);
        // }
        });
      })
      
    }
    if (Type === "remove") {
      // debugger;
      let data = _.cloneDeep([...this.state.tableProceuresData]);
      const index = data.findIndex((xvalue) => xvalue.procedureId === item);
      if(index!==-1){
      data.splice(index, 1);
      this.setState({ tableProceuresData: data, isChanges: true,isNew:false },()=>{
        // if (this.refAddProcedure.current !== null){
        //   this.refAddProcedure.current.upatedProcedureList(this.state.tableProceuresData);
        // }
        
      });
      }
    }
  }

  countUpdate = (state: any,stype:any) => {
    
    let totalRoom = state.filter(
      (x: any) => x.type.toLowerCase() !== "roomtype"
    );
     if(stype!=="notechange"){
      this.setState({ isChanges: true,isNew:false });
     }
    this.setState({ isCountLocation: totalRoom.length, tableLocationData: totalRoom });
  }
  isOnsavemaintenance = () => {
    if(this.state.isScheduleExistsShow){
      confirmAlert({
        title: "Are you sure?",
        message:
          `This schedule is currently active. Changes made will be saved but will not affect the current instance. Your changes will take effect starting with the next scheduled instance on ${this.props.parentState.manageParentRowData[0]?.nextOccurrence}.`,
        buttons: [
          {
            label: "Save Changes",
            onClick: () => this.onSaveMaintenance(),
          },
          {
            label: "Cancel",
            onClick: () => { },
          },
        ],
        closeOnEscape: false,
        closeOnClickOutside: false,
      });
    }
    else{
      this.onSaveMaintenance()
    }
  }

  onSaveMaintenance = () => {
    let tableLocationData = [...this.state.locationControl];
    let tempProceuresData = [...this.state.tableProceuresData];
    if(tableLocationData.length===0){
      Utils.toastError(`Please add atleast one location`, {
        position: toast.POSITION.BOTTOM_RIGHT,
        containerId: "MaintenceShudleSldieOut",
      });
      return;
    }
    

    let mainData: any = [];
    let mainDataObject: any = {};
    const storage = JSON.parse(localStorage.getItem("storage")!);
    let User_UniqueID = storage === null ? 0 : (storage.user_UniqueID as any);
    let TenantId = storage === null ? 0 : (storage.tenantID as any);
    mainDataObject.ProjectName = this.state.scheduleData[0]?.name;
    mainDataObject.StartDate =  moment(this.state.startDate).format("MM/DD/YYYY");
    mainDataObject.description = this.state.description;
    // mainDataObject.NextStartDate = this.state.nextOccurrenceDate;    
    mainDataObject.EndDate = moment(this.state.endDate).format("MM/DD/YYYY");
    let nextStartDate = "";
    const isScheduleExists = this.props.parentState.tableData.some(
      (item) => item.maintenanceScheduleId === this.state.scheduleData[0]?.id
    );
    const isScheduleExistsList = [...this.props.parentState.tableData]
    .sort((a, b) => new Date(b.startDate).getTime() - new Date(a.startDate).getTime())[0];

    const frequencyUnit = this.state.showCustomdropdown ? 
    (this.state.customFrequenId == 0 ? this.state?.freequencyList?.find((item) => item.name.toLowerCase() === (this.props.parentState.manageParentRowData[0]?.frequenId == 1 ?
      this.props.parentState.manageParentRowData[0]?.frequencyOrginalValue?.toLowerCase() + 's' : 
      this.props.parentState.manageParentRowData[0]?.frequencyOrginalValue?.toLowerCase()))?.id || this.state.customFrequenId : this.state.customFrequenId)
    : (this.state.mainFrequenId == 0 ? (this.state?.mainFrequencyList?.find((item) => item.name.toLowerCase() === this.props.parentState.manageParentRowData[0]?.frequencyOrginalValue?.toLowerCase())?.id || this.state.mainFrequenId) : this.state.mainFrequenId);
    const frequencyValue = this.state.showCustomdropdown ? this.state.frequencyCustomValue : 1;
    const frequencyMapping = {
      1: 'days',
      2: 'weeks',
      3: 'months',
      4: 'years',
      5: 'quarters',
    };
    // Check for valid frequency
    if (frequencyMapping[frequencyUnit]) {
      nextStartDate = moment(isScheduleExists ? isScheduleExistsList.startDate :this.state.startDate)
      // nextStartDate = moment(isScheduleExists ? this.props.parentState.manageParentRowData[0].nextOccurrence:this.state.startDate)
        .add(Number(frequencyValue), frequencyMapping[frequencyUnit])
        .format("MM/DD/YYYY");
    }
    
    mainDataObject.NextStartDate = this.props.parentState.manageParentRowData[0].nextOccurrence == "" ? moment(this.state.startDate).format("MM/DD/YYYY") : nextStartDate ;
    let mainFrequenId = this.state.mainFrequenId == 0 ? (this.state?.mainFrequencyList?.find((item) => item.name.toLowerCase() === this.props.parentState.manageParentRowData[0]?.frequencyOrginalValue?.toLowerCase())?.id || this.state.mainFrequenId) : this.state.mainFrequenId;
    let customFrequenId = this.state.customFrequenId == 0 ?(this.state?.freequencyList?.find((item) => item.name.toLowerCase() === (this.props.parentState.manageParentRowData[0]?.frequenId == 1 ?
    this.props.parentState.manageParentRowData[0]?.frequencyOrginalValue?.toLowerCase() + 's' : 
    this.props.parentState.manageParentRowData[0]?.frequencyOrginalValue?.toLowerCase()))?.id || this.state.customFrequenId):this.state.customFrequenId;
    if(this.state.showCustomdropdown)
      {
        mainDataObject.Frequency = customFrequenId == "1" ?
                                  (this.state.frequencyCustomValue == 1 ? "Day" : "Days") : customFrequenId == "2" ? 
                                  (this.state.frequencyCustomValue == 1 ? "Week" : "Weeks") : customFrequenId == "3" ? 
                                  (this.state.frequencyCustomValue == 1 ? "Month" : "Months") : customFrequenId == "4" ? 
                                  (this.state.frequencyCustomValue == 1 ? "Year" : "Years") : "";
        mainDataObject.FrequencyValue = this.state.frequencyCustomValue;
      }
      else{
        mainDataObject.Frequency = mainFrequenId == "1" ?
                                  "Daily" : mainFrequenId == "2" ? 
                                  "Weekly" : mainFrequenId == "3" ? 
                                  "Monthly" : mainFrequenId == "4" ? 
                                  "Yearly" : mainFrequenId == "5" ? 
                                  "Quarterly" : "";
        mainDataObject.FrequencyValue = "1";
      }
    mainDataObject.Hid = Number(this.props.parentState.hidValue);
    mainDataObject.TenantId = TenantId;
    mainDataObject.Pririty = this.state.priority;
    mainDataObject.AssignedTo = this.state.assignedTo;
    //mainData.push(mainDataObject);

    let procedureData: any = [];
    //let tempProceuresData = [...this.state.tableProceuresData];
    tempProceuresData.forEach(element => {
      let procedureDataObject: any = {};
      procedureDataObject.ProcedureId = element.procedureId;
      procedureData.push(procedureDataObject);
    });


    let locationData: any = [];

   
    tableLocationData.forEach(element => {
      let locationDataObject: any = {};
      locationDataObject.LocationId = element.roomID;
      locationData.push(locationDataObject);
    });


    let request: any = {};
    request.scheduleMaintenanceRequest = _.cloneDeep((mainDataObject));
    request.procedureIds = _.cloneDeep(procedureData);
    request.locationIds = _.cloneDeep(locationData);
    

    FacilityMaintenance.SaveMaintenance(request)
      .then(async (result: any | null) => {
        if (result !== null) {
         

          if (result.saveStatus === "Success") {
            toast.success("Maintenance Schedule saved successfully", {
              position: toast.POSITION.BOTTOM_RIGHT,
              containerId: "MaintenceShudleSldieOut",
            });
            this.setState({isChanges:false})
            this.props.saveCloseWorkSlideOut();

          }
          else {


          }

        }
        resolve();
      })
      .catch((error) => {
        reject();
      });

  }

  handleProcedureSlideout = (row:any) => {
   
    let procedureData:any={};
    procedureData.procedureId=row.procedureId;
    procedureData.procedureName=row.procedureName;   
    let Data:any=[];
    
   Data.push(procedureData);

    this.setState({ isSlideOut: false,isProcedureRow:Data},()=>{
      this.setState({ isProcedureMaintenanceSlideout: true });
      });
    
  }

  closeProcedureSlideout = (isReload) => {
    this.setState({ isProcedureMaintenanceSlideout: false })
  }

  onDiscardChanges = (Type:any) => {
    if(Type==="Discard"){
    let tableProceuresData=_.cloneDeep([...this.state.temptableProceuresData]);
    let tempTableproceduresList=_.cloneDeep([...this.state.tempTableproceduresList]);
   let temppri= this.state.scheduleData[0]?.priority;
      this.setState({ isChanges: false,tableProceuresData:tableProceuresData,proceduresList:tempTableproceduresList,priority: temppri,isRefresh:true},()=>{
        // if (this.refMaintenanceLocationSlideOut.current !== null){        
        //   this.refMaintenanceLocationSlideOut.current.GetMLocationDetails("onDiscardChanges");
        //   this.refMaintenanceLocationSlideOut.current.GetAllMLocationDetails("onDiscardChanges");       
        // }
        // if (this.refAddProcedure.current !== null){
        //   this.refAddProcedure.current.discardChanges();
        //   this.refAddProcedure.current.upatedProcedureList(this.state.tableProceuresData);
        // }
        this.setState({isRefresh:false});
      });
     
      toast.success("Pending changes discarded successfully.", {
        position: toast.POSITION.BOTTOM_RIGHT,
         containerId: "MaintenceShudleSldieOut",
      });
    }else{
      this.closeWorkSlideOut();
    }
    
  }
  
  hideApprovalModal = (value) => {
  
    this.isValidateModelPoupTab(value);
  }


  isValidateModelPoupTab(value) {
    confirmAlert({
      title: "Unsaved confirmation",
      message:
        "You have unsaved changes on this page. Do you want to leave this page and discard your changes?",
      buttons: [
        {
          label: "Yes",
          onClick: () => this.isChangeUnsaved(value),
        },
        {
          label: "No",
          onClick: () => reject(),
        },
      ],
      closeOnEscape: false,
      closeOnClickOutside: false,
    });
  }

  isChangeUnsaved = (value) => {
    this.props?.closeWorkSlideOut();

  }

  onDDlFiltersChange = (controlID: any, id: any) => {
   
    let { frequency, status, priority } = this.state;
    switch (controlID) {    
      case "ddlPriority":
        priority = id || "";
        break;
      default:
        break;
    }

    this.setState({ priority,isChanges:true,isNew:false}, () => {
      
    });
  };

//  upatedProcedureTable=()=>{
//   if (this.refAddProcedure.current !== null){
//     this.refAddProcedure.current.upatedProcedureList();
//   }
//  }
openCalendar = (inputPosition) => {
  this.setState({
    calendarOpened: inputPosition === 1,
    endCalendarOpened: inputPosition === 2,
  });
};
calenderHide = () => {
  this.setState({ calendarOpened: false, dueDatecalendarOpened: false,endCalendarOpened:false });
};
changestartDate = (event, inputPosition) => {
    let {endDate,startDate} = this.state;
    let calenderYeare = event.getFullYear().toString();
    let calenderDatee =
      event.getDate() > 9 ? event.getDate() : 0 + "" + event.getDate();
    let calenderMonthe =
      event.getMonth() + 1 > 9
        ? event.getMonth() + 1
        : 0 + "" + (event.getMonth() + 1);
    let tempDatee = calenderMonthe + "/" + calenderDatee + "/" + calenderYeare;
    if (inputPosition === 1) {
      this.setState({ calendarOpened: false,startDate: tempDatee,isChanges: this.state.startDate == tempDatee ? false : true});
      if (endDate && moment(endDate, "MM/DD/YYYY").isSameOrBefore(moment(tempDatee, "MM/DD/YYYY"))) {
          this.setState({endDate: ""});
        }
    } else if (inputPosition === 2) {
      this.setState({ endCalendarOpened: false,endDate: tempDatee,isChanges: this.state.endDate == tempDatee ? false : true});
    }
    this.validationOnClick(2)
  }
handleSelectedItem = (controlID: any, id: any) => {
  let frequencyName = this.props.parentState.manageParentRowData[0]?.frequencyOrginalValue;
  frequencyName = ((this.props.parentState.manageParentRowData[0]?.frequenId == 1) ? frequencyName + "s" : frequencyName);
  let mainFrequenId =(this.state?.mainFrequencyList?.find((item) => item.name.toLowerCase() === this.props.parentState.manageParentRowData[0]?.frequencyOrginalValue?.toLowerCase())?.id || this.state.mainFrequenId);
  let customFrequenId =(this.state?.freequencyList?.find(
    (item) => item.name.toLowerCase() === frequencyName?.toLowerCase()
  )?.id || this.state.customFrequenId)
  if (controlID === 1) {
    if(id == 6){
      this.setState({ mainFrequenId: 6, isChanges: false ,showCustomdropdown:true,frequencyCustomValue:"",zeroValidation:false},() =>{
        const errors = this.validateConfigurationFormSchema();
      if (errors && errors.frequencyCustomValue) {
        const updatedErrors = { ...errors };
        delete updatedErrors.frequencyCustomValue;
        this.setState({
          errors: updatedErrors,
          isFormNotValid: Object.keys(updatedErrors).length > 0
        });
      }
      });
      this.validateConfigurationFormSchema()
    }
    else{
      this.setState({ mainFrequenId: id,isChanges: mainFrequenId == id ? false : true,showCustomdropdown:false });
    }
  }
  if (controlID === 2) {
      this.setState({ customFrequenId: id ,isChanges: this.state.customFrequenId == id ? false : true});
      this.validationOnClick(2)
  }
  if(controlID === 3){
    this.setState({assignedTo:id,isChanges: this.state.assignedTo == id ? false : true});
    this.validationOnClick(2)
  }
  // this.validationOnClick(1)
};
onFieldChange = (event, inputPosition) => {
  // const { FormData } = this.state;
  let value = event.target.value;
  const fieldName = event.target.name;
  if(fieldName === "description"){
    value = value?.toString()?.trimLeft();
    if(value == "")
    {
      this.setState({description:value,isChanges: false})
    }
    else{
    this.setState({description:value,isChanges: true},()=> {
      this.validationOnClick(inputPosition)
    })
    }
  }
  if (fieldName === "frequencyCustomValue") {
    const strippedValue = value.replace(/^0+/, "");
    if (strippedValue === "0" || strippedValue === "") {
      this.setState({zeroValidation:true,isChanges: false });
    } else {
      value = strippedValue != "" ? strippedValue :value;
      this.setState({zeroValidation:false,isChanges: true });
    }
    this.setState({frequencyCustomValue:value},()=> {
      this.validationOnClick(inputPosition)
    })
  }
 
};
validationOnClick = (inputPosition) => {
    this.setState({ inputPosition }, () =>
      this.validateConfigurationFormSchema()
    );
  };

  validateConfigurationFormSchema = (isAssetNameChanged = false) => {
    // debugger
    const { description, frequencyCustomValue } = this.state;
    const valid = Joi.validate(
      { description, frequencyCustomValue },
      this.FormSchema,
      { abortEarly: false }
    );
    const newErrorObject: any = {};
    if (valid.error) {
      valid.error.details.forEach((err) => {
        newErrorObject[err.path.join(".")] = err.message;
      });
    }
    if (frequencyCustomValue == "0" || frequencyCustomValue == "00" || frequencyCustomValue == "000") {
      newErrorObject["frequencyCustomValue"] = "Please enter a value greater than 0";
    }  
    if (Object.keys(newErrorObject).length === 0) {
      this.setState({ isFormNotValid: false });
    } else {
      this.setState({ isFormNotValid: true });
    }
    this.setState({ errors: newErrorObject });
    return newErrorObject;
  };
  handleAccordionToggle = (eventKey) => {
    this.setState((prevState) => {
      const { activeKeys } = prevState;
      return {
        activeKeys: activeKeys.includes(eventKey)
          ? activeKeys.filter((key) => key !== eventKey)
          : [...activeKeys, eventKey],
      };
    });
  };
selectProcedureListSlideOut=(procedureList)=>
{
  const updatedList = procedureList.map(item => {
    if (item.assetname?.includes("Location:")) {
      return { ...item, assetname: "" };
    }
    return item;
  });
  // const isSame = this.state.tableProceuresData.length == 0 ? true : JSON.stringify(updatedList) === JSON.stringify(this.state.tableProceuresData);
  this.setState({tableProceuresData:updatedList,isChanges: true,showProcedures:true })
  this.validationOnClick(2)
  if (this.refAddProcedure.current !== null){            
      this.refAddProcedure.current.upatedProcedureList(updatedList);
    }
}
selectLocationList=(locationList:any)=>{
  const updatedLocationList = locationList.map((location: any) => ({
    ...location,
    roomID: location.id,  
  }));
  this.setState({locationControl:updatedLocationList,isChanges: true,showLocations:true });
  this.validationOnClick(2)
  // this.props.countUpdate(locationList,"Add");
  if (this.refLocationAdded.current !== null){
    this.refLocationAdded.current.upatedLocationList(locationList,this.state.roomTypeData);
  }
}
removeProcedure(row){
  const updatedTableProceuresData = this.state.tableProceuresData.filter(
    procedure => procedure.procedureId !== row.procedureId
  );

  this.setState({
    tableProceuresData: updatedTableProceuresData,isChanges: true
  });
  if (this.refAddProcedure.current !== null){            
    this.refAddProcedure.current.upatedProcedureList(updatedTableProceuresData);
  }
}
removeLocation(row){
  const updatedTablelocationControl = this.state.locationControl.filter(
    location => location.roomID !== row.roomID
  );
  if(this.state.locationControl.length == 1){
    toast.error("At least one location must be associated with a maintenance schedule", {
      position: toast.POSITION.BOTTOM_RIGHT,
      containerId: "MaintenceShudleSldieOut",
    });
    return;
  }
  else{
  this.setState({
    locationControl: updatedTablelocationControl,isChanges: true
  });
  }
  if (this.refLocationAdded.current !== null){
    this.refLocationAdded.current.upatedLocationList(updatedTablelocationControl,this.state.roomTypeData);
  }
    
}
hanldeDeleteConfirmation = () => {
    confirmAlert({
      title: "Warning!",
      message:
        "Deleting this schedule will permanently remove all historical data associated with it. This action cannot be undone. Are you sure you want to delete this schedule?",
      buttons: [
        {
          label: "Delete",
          onClick: () => this.deleteMaintenanceSchedule(this.state.scheduleData[0]?.id),
        },
        {
          label: "Cancel",
          onClick: () => { },
        },
      ],
      closeOnEscape: false,
      closeOnClickOutside: false,
    });
  };
  deleteMaintenanceSchedule = (id) => {
    FacilityMaintenance.DeleteMaintenanceSchedule(id)
      .then((response: any) => {
        if (response?.success) {
          toast.success("PM Schedule successfully deleted", {
            position: toast.POSITION.BOTTOM_RIGHT,
          });
          this.props.saveCloseWorkSlideOut();
        } else {
          Utils.toastError(response.result, {
            position: toast.POSITION.BOTTOM_RIGHT,
          });
        }
      })
      .catch((error) => {
        Utils.toastError(error.response.data, {
          position: toast.POSITION.BOTTOM_RIGHT,
        });
      });
  };
  closeCalendar = (inputPosition) => {
    this.setState({
        endDate: '',
        endCalendarOpened: false,
        isChanges: true
    });
  };
  scrollToDropDown = () => {  }
  render() {
    const isScheduleExists = this.props.parentState.tableData.some(
      (item) => item.maintenanceScheduleId === this.state.scheduleData[0]?.id
    );
    const sortedProcedureData = [...this.state.tableProceuresData].sort((a, b) => {
      const nameA = (a.procedureName || a.name || "").toLowerCase();
      const nameB = (b.procedureName || b.name || "").toLowerCase();
      return nameA.localeCompare(nameB);
    });
    const {      
      priority,
      name,
      description,
      startDate,
      endDate,
      frequencyValue,
      frequency,
      frequencyCustomValue,
      errors,
      inputPosition,
      frequencyCustom,
    } = this.state;
    let frequencyName = this.props.parentState.manageParentRowData[0]?.frequencyOrginalValue;
    frequencyName = ((this.props.parentState.manageParentRowData[0]?.frequenId == 1 && frequencyCustom) ? frequencyName + "s" : frequencyName);
    const mainFrequenId = !frequencyCustom ? (this.state?.mainFrequencyList?.find(
      (item) => item.name.toLowerCase() === frequencyName?.toLowerCase()
    )?.id || -1): 6;
    const customFrequenId = frequencyCustom ? (this.state?.freequencyList?.find(
      (item) => item.name.toLowerCase() === frequencyName?.toLowerCase()
    )?.id || -1): 1;

    const {createEditPermission}=this.props.parentState;

    const columns = [
      {
        dataField: "procedureName",
        text: "Name",
        formatter: (cell: any, row: any, rowIndex: any) => {
          const displayName = row.procedureName || row.name || "-";
          return (
            <>
              <EllipsisWithTooltip placement="bottom">
                {displayName}
              </EllipsisWithTooltip>
            </>
          );
        },

      },
      {
        dataField: "assetName",
        text: "Asset",
        headerFormatter: (column) => {
          return (
            <>
              <span>Asset</span>
              {/* <OverlayTrigger 
              overlay={<Tooltip id="asset-info">Procedure applies to assets of a matching type for each location</Tooltip>}
              placement="bottom" 
              delay={{ show: 250, hide: 400 }} 
              >
              <div>
                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                  <g clip-path="url(#clip0_361_12954)"><path d="M8.66649 7.33307H7.33315V11.3331H8.66649V7.33307Z" fill="#6A6E73"/><path d="M8.66649 4.66641H7.33315V5.99974H8.66649V4.66641Z" fill="#6A6E73"/><path fill-rule="evenodd" clip-rule="evenodd" d="M15.1998 7.9998C15.1998 11.9763 11.9763 15.1998 7.9998 15.1998C4.02335 15.1998 0.799805 11.9763 0.799805 7.9998C0.799805 4.02335 4.02335 0.799805 7.9998 0.799805C11.9763 0.799805 15.1998 4.02335 15.1998 7.9998ZM14.3998 7.9998C14.3998 11.5344 11.5344 14.3998 7.9998 14.3998C4.46518 14.3998 1.5998 11.5344 1.5998 7.9998C1.5998 4.46518 4.46518 1.5998 7.9998 1.5998C11.5344 1.5998 14.3998 4.46518 14.3998 7.9998Z" fill="#6A6E73"/>
                  </g><defs><clipPath id="clip0_361_12954"><rect width="16" height="16" fill="white"/></clipPath></defs>
                  </svg>
                {column.assetName}
              </div>
            </OverlayTrigger> */}
            </>
          )
        },
        formatter: (cell: any, row: any, rowIndex: any) => {
          return (
            
            row.assetName?.trim().length >= 1 ? 
              <div className={`${(row.assetName?.length >= 1 && row.assetName!==" " ) ? "badge asset-badge" : ""}`}>
                <EllipsisWithTooltip placement="bottom">
                  {row.assetName}
                </EllipsisWithTooltip>
              </div> 
              :
              <></>
          );
        },

      },


      {
        dataField: "",
        text: "",
        formatter: (cell: any, row: any, rowIndex: any) => (
          <Dropdown
            // onClick={(e) => {
            //   e.stopPropagation();
            // }}
            className="more-action position-static text-right"
            alignRight
          >
            <Dropdown.Toggle
              className="btn-outline-primary btn btn-primary btn-ghost more"
              id="dropdown-more"
            // disabled={!this.state?.createEditPermission || selectedRows?.length > 0}
            >
              <svg
                width="20"
                height="20"
                viewBox="0 0 20 20"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path d="M11.875 10C11.875 11.0352 11.0352 11.875 10 11.875C8.96484 11.875 8.125 11.0352 8.125 10C8.125 8.96484 8.96484 8.125 10 8.125C11.0352 8.125 11.875 8.96484 11.875 10Z" />
                <path d="M5.625 10C5.625 11.0352 4.78516 11.875 3.75 11.875C2.71484 11.875 1.875 11.0352 1.875 10C1.875 8.96484 2.71484 8.125 3.75 8.125C4.78516 8.125 5.625 8.96484 5.625 10Z" />
                <path d="M18.125 10C18.125 11.0352 17.2852 11.875 16.25 11.875C15.2148 11.875 14.375 11.0352 14.375 10C14.375 8.96484 15.2148 8.125 16.25 8.125C17.2852 8.125 18.125 8.96484 18.125 10Z" />
              </svg>
            </Dropdown.Toggle>
            <Dropdown.Menu>
              {(Number(row.inUse) !== 1) &&
                <Dropdown.Item
                className="border-0"
                onClick={() => this.removeProcedure(row)} 
                >
                  Remove
                </Dropdown.Item>
              }
            </Dropdown.Menu>
          </Dropdown>
        ),
      },
    ];
    const columns2 = [
        {
          dataField: "name",
          text: "Name",
          formatter: (cell: any, row: any, rowIndex: any) => {
            return (
              <>
                <EllipsisWithTooltip placement="bottom">
                  {row.name}
                </EllipsisWithTooltip>
              </>
            );
          },
  
        },
        {
            dataField: "category",
            text: "Type",
            formatter: (cell: any, row: any, rowIndex: any) => {
              const displayName = row.category || row.type || "-";
              return (
                <>
                  <EllipsisWithTooltip placement="bottom">
                    {displayName}
                  </EllipsisWithTooltip>
                </>
              );
            },
    
        },
  
        
        // {
        //   dataField: "",
        //   text: "",
        //   formatter: (cell: any, row: any, rowIndex: any) => (
            
        //     <Dropdown
        //       // onClick={(e) => {
        //       //   e.stopPropagation();
        //       // }}
        //       className="more-action position-static text-right"
        //       alignRight
        //     >
        //       <Dropdown.Toggle
        //         className="btn-outline-primary btn btn-primary btn-ghost more"
        //         id="dropdown-more"
        //         //</Dropdown>disabled={!this.state?.createEditPermission || selectedRows?.length > 0
        //         //}
        //       >
        //         <svg
        //           width="20"
        //           height="20"
        //           viewBox="0 0 20 20"
        //           fill="none"
        //           xmlns="http://www.w3.org/2000/svg"
        //         >
        //           <path d="M11.875 10C11.875 11.0352 11.0352 11.875 10 11.875C8.96484 11.875 8.125 11.0352 8.125 10C8.125 8.96484 8.96484 8.125 10 8.125C11.0352 8.125 11.875 8.96484 11.875 10Z" />
        //           <path d="M5.625 10C5.625 11.0352 4.78516 11.875 3.75 11.875C2.71484 11.875 1.875 11.0352 1.875 10C1.875 8.96484 2.71484 8.125 3.75 8.125C4.78516 8.125 5.625 8.96484 5.625 10Z" />
        //           <path d="M18.125 10C18.125 11.0352 17.2852 11.875 16.25 11.875C15.2148 11.875 14.375 11.0352 14.375 10C14.375 8.96484 15.2148 8.125 16.25 8.125C17.2852 8.125 18.125 8.96484 18.125 10Z" />
        //         </svg>
        //       </Dropdown.Toggle>
        //       <Dropdown.Menu>
                
        //         <Dropdown.Item 
        //         // onClick={this.handleBulkSelect}
        //         onClick={(e: any) =>
        //           this.handleBulkSelect(e, row, rowIndex)
        //         }
        //         >
        //           Bulk Select</Dropdown.Item>
        //         <Dropdown.Item
        //          onClick={(e: any) =>
        //         //  this.handleSingleDelete(e, row, rowIndex)
        //         this.isDeleteConfirmationPoupTab(e, row, rowIndex,"Delete")
        //         }
        //         >
        //           Delete
        //         </Dropdown.Item>
        //       </Dropdown.Menu>
        //     </Dropdown>
        //   ),
        // },

        {
          dataField: "",
          text: "",
          editable: false,
          formatter: (cell: any, row: any, rowIndex: any) => {
            // const stopPropagation = (e: { stopPropagation: () => any }) =>
            // e.stopPropagation();
            // if (row.flyOutAction === "") {
              return (
                // <OutsideClickHandler onOutsideClick={(e)=>this.ddlDeptdetails() }>
                <Dropdown
                  className="more-action position-static"
                  alignRight
                  // onClick={stopPropagation}
                >
                  <Dropdown.Toggle
                    className="btn-outline-primary btn btn-primary more"
                    id="dropdown-more"
                    disabled={this.props.disabled}
                    //ref={row?.ddlDeptdetailsRef}
                  >
                    <svg
                      width="20"
                      height="20"
                      viewBox="0 0 20 20"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path d="M11.875 10C11.875 11.0352 11.0352 11.875 10 11.875C8.96484 11.875 8.125 11.0352 8.125 10C8.125 8.96484 8.96484 8.125 10 8.125C11.0352 8.125 11.875 8.96484 11.875 10Z" />
                      <path d="M5.625 10C5.625 11.0352 4.78516 11.875 3.75 11.875C2.71484 11.875 1.875 11.0352 1.875 10C1.875 8.96484 2.71484 8.125 3.75 8.125C4.78516 8.125 5.625 8.96484 5.625 10Z" />
                      <path d="M18.125 10C18.125 11.0352 17.2852 11.875 16.25 11.875C15.2148 11.875 14.375 11.0352 14.375 10C14.375 8.96484 15.2148 8.125 16.25 8.125C17.2852 8.125 18.125 8.96484 18.125 10Z" />
                    </svg>
                  </Dropdown.Toggle>
                  <Dropdown.Menu>
                  <Dropdown.Item
                  className="border-0"
                  onClick={(e: any) =>this.removeLocation(row)}
                  >
                    Remove
                  </Dropdown.Item>
                  </Dropdown.Menu>
                </Dropdown>
                // </OutsideClickHandler>
              );
          
          // }
        },
      }
    ];

    const tableRowEvents = {

      onClick: (e, row, rowIndex) => {
        this.handleProcedureSlideout(row)
      },
    }
    return (
      <>

        {/* <OutsideClickHandler onOutsideClick={(e: any) => this.hideApprovalModal("sideClick")}
                > */}

        <div className="pos-fxd index-1000" id="maintenance-slideout">
          <div className={`slideOut-wrapper ${this.state.isChanges ? "set-bulk-banner" : ""}`}>
            <div className="d-flex">
              <div className="back-drop" onClick={this.closeWorkSlideOut}></div>
              <Container
                fluid
                className="body-sec"
                onScroll={(e) => {this.refAddProcedure?.current?.removeTooltip()}}
              >
                <div className="page-heading d-flex">

                  <div className="user-details align-items-center mr-auto">
                    <div className="maintenance-title">
                      <EllipsisWithTooltip placement="bottom">
                      {this.state.scheduleData[0]?.name}
                      </EllipsisWithTooltip>
                    </div>
                    <div className="position-name">Maintenance Schedule</div>
                  </div>

                  <div className="d-flex">
                  {!this.state.isScheduleExistsShow && 
                    <Dropdown className="more-action" alignRight>
                      <Dropdown.Toggle
                        className="btn-outline-primary btn btn-primary more border-0"
                        id="dropdown-more"
                        disabled={!createEditPermission}
                      >
                        <svg
                          width="20"
                          height="20"
                          viewBox="0 0 20 20"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path d="M11.875 10C11.875 11.0352 11.0352 11.875 10 11.875C8.96484 11.875 8.125 11.0352 8.125 10C8.125 8.96484 8.96484 8.125 10 8.125C11.0352 8.125 11.875 8.96484 11.875 10Z" />
                          <path d="M5.625 10C5.625 11.0352 4.78516 11.875 3.75 11.875C2.71484 11.875 1.875 11.0352 1.875 10C1.875 8.96484 2.71484 8.125 3.75 8.125C4.78516 8.125 5.625 8.96484 5.625 10Z" />
                          <path d="M18.125 10C18.125 11.0352 17.2852 11.875 16.25 11.875C15.2148 11.875 14.375 11.0352 14.375 10C14.375 8.96484 15.2148 8.125 16.25 8.125C17.2852 8.125 18.125 8.96484 18.125 10Z" />
                        </svg>
                      </Dropdown.Toggle>
                      <Dropdown.Menu>
                          <Dropdown.Item
                          className="border-0"
                          onClick={() => this.hanldeDeleteConfirmation()}
                          >Delete Schedule</Dropdown.Item>
                        
                      </Dropdown.Menu>
                    </Dropdown>
                    }
                    <button
                      type="button"
                      className="btn wht-bg cross pr-0 pl-2"
                      onClick={this.closeWorkSlideOut}
                    >
                      <svg
                        width="24"
                        height="24"
                        viewBox="0 0 24 24"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M16.192 6.34399L11.949 10.586L7.70697 6.34399L6.29297 7.75799L10.535 12L6.29297 16.242L7.70697 17.656L11.949 13.414L16.192 17.656L17.606 16.242L13.364 12L17.606 7.75799L16.192 6.34399Z"
                          fill="#84888C"
                        />
                      </svg>
                    </button>
                  </div>

                </div>
                <div className="info infoslideout">
                  <h3 className="title mb-4">Details</h3>
                  <div className="form-wrapper">
                      <Form.Group onBlur={() => this.validationOnClick(1)} className="d-flex mb-1">
                        <Col
                          sm={"12"}
                          className={`mb-0 p-0 ${errors?.description
                            ? "validation-error flex-column"
                            : ""
                            }`}
                        >
                          <div className="form-item">
                            <div className="item-label">
                              <Form.Label>Description</Form.Label>
                            </div>
                            <div>
                            <OverlayTrigger
                              placement="bottom"
                              delay={{ show: 250, hide: 400 }}
                              overlay={
                                <Tooltip
                                  id={"Description"}
                                  className={this.state.description && Utils.CapitalizeFirstLetter(description).length >= 28 ? "" : "tootltip-hide"}
                                >
                                  {Utils.CapitalizeFirstLetter(description)}
                                </Tooltip>
                              }
                            >
                              <Form.Control
                                type="text"
                                className={`form-control text-truncate description ${errors?.description
                                  ? "border pl-2"
                                  : ""
                                  }`}
                                // tabIndex={1}
                                maxLength={200}
                                id="description"
                                name="description"
                                autoComplete="description"
                                value={description}
                                placeholder="Add a Description"
                                onChange={(e) => this.onFieldChange(e, 1)}
                                onBlur={() => { this.setState({ description: description.trimRight()}) }}
                              />
                            </OverlayTrigger>
                            {this.state.errors?.description && (
                              <div className="pt-1 text-danger">{this.state.errors.description}</div>
                            )}
                            </div>
                          </div>
                        </Col>
                      </Form.Group>
                      <div className="form-item">
                        <div className="item-label">
                          <Form.Label>Frequency</Form.Label>
                        </div>
                        <div>
                          <SingleSearchDropdownList
                            // // isdisable={this.props.locationDisable}
                            isRefresh={this.state.isRefresh}
                            itemList={this.state.mainFrequencyList}
                            handleSelectedItem={this.handleSelectedItem.bind(
                              this,
                              1
                            )}
                            defaultItem={this.state.mainFrequencyList}
                            defaultText={"Frequency"}
                            defaultName={this.state.mainFrequencyList.filter((item) => item.id === mainFrequenId)[0]?.name}
                            controlID="1"
                            allowSearch={false} 
                          // isdisable={this.state.allWorkorderCount > 0 ? true : false}
                          // isdisable={this.props.parentState.PageType === "locationWorkOrder" || this.props.parentState.workorderPermission === "No" ? true : false}
                          />
                          {this.state.showCustomdropdown && (
                            <div className="d-flex align-items-center customDropdown mt-1">
                              <span className="mr-2 text-muted">Every</span>
                              <Form.Group
                                onBlur={() => this.validationOnClick(2)}
                                  style={{ width: "15%" }} className="mb-0 mr-1">
                                <Col
                                  sm={"12"}
                                  className={`mb-0 p-0 col-left d-flex align-items-baseline ${errors?.frequencyCustomValue  ? "validation-error" : ""}`}
                                // onClick={() => this.validationOnClick(1)}
                                >
                              <Form.Control
                                type="text"
                                inputMode="numeric"
                                className="form-control w-100 frequencyCustomValue"
                                pattern="[0-9]*"
                                maxLength={3}
                                // tabIndex={1}
                                // min={1}
                                id="frequencyCustomValue"
                                name="frequencyCustomValue"
                                autoComplete="frequencyCustomValue"
                                value={frequencyCustomValue}
                                onKeyDown={Utils.AllowOnlyPositiveNumnberInputWithoutDot}
                                onChange={(e) => this.onFieldChange(e, 2)}
                                onBlur={() => { this.setState({ frequencyCustomValue: frequencyCustomValue}) }}
                              />
                            </Col>
                              </Form.Group>
                                <div className="days-dropdown">
                                <SingleSearchDropdownList
                                  // // isdisable={this.props.locationDisable}
                                  isRefresh={this.state.isRefresh}
                                  itemList={this.state.freequencyList}
                                  handleSelectedItem={this.handleSelectedItem.bind(
                                    this,
                                    2
                                  )}
                                  defaultItem={this.state.freequencyList}
                                  defaultText={"Frequency"}
                                  defaultName={this.state.freequencyList.filter((item) => item.id === customFrequenId)[0]?.name}
                                  controlID="2"
                                  allowSearch={false} 
                                // isdisable={this.state.allWorkorderCount > 0 ? true : false}
                                // isdisable={this.props.parentState.PageType === "locationWorkOrder" || this.props.parentState.workorderPermission === "No" ? true : false}
                                />
                              </div>
                            </div>
                            
                          )}
                          {errors?.frequencyCustomValue && this.state.showCustomdropdown && <div className=" pt-1 error-message">{errors.frequencyCustomValue}</div>}
                          {/* {errors?.frequencyCustomValue && this.state.zeroValidation && (
                            <div className="pt-1 error-message">Please enter a value greater than 0</div>
                          )} */}
                        </div>
                      </div>
                      <div className="form-item">
                        <div className="item-label">
                          <Form.Label>Start Date</Form.Label>
                        </div>
                        <div className="calender-picker input-form-calender">
                          <Form.Control placeholder="Select Start Date"
                            autoComplete='off'
                            type="text" id="startDate" name='startDate'
                            value={startDate}
                            readOnly
                            className={`form-control text-truncate ${
                              isScheduleExists ? 'disabled-pointer' : ''
                            }`}
                            disabled={isScheduleExists}
                            // ref={this.openingDateRef}
                            onClick={() => this.openCalendar(1)}
                          />
                          {this.state.calendarOpened
                            ?
                            <OutsideClickHandler
                              onOutsideClick={this.calenderHide}
                            >
                              <div className="calender startDate">
                                <Calendar
                                  calendarType={"US"}
                                  onChange={(e) => this.changestartDate(e, 1)}
                                  value={
                                    startDate ? moment(startDate)?.format("MM/DD/YYYY") === "invalid date"
                                      ? ""
                                      : new Date(startDate)
                                      : ""
                                  }
                                minDate={this.state.currentDate}
                                />
                              </div>
                            </OutsideClickHandler>
                            : null}
                        </div>
                      </div>
                      {/* <div className="form-item">
                        <div className="item-label">
                          <h6>Next Occurrence Date</h6>
                        </div>
                        <div className="item-value">{this.state.scheduleData[0]?.nextOccurrenceDate}</div>
                      </div> */}
                      <div className="form-item">
                        <div className="item-label">
                          <Form.Label>End Date</Form.Label>
                        </div>
                        <div className="calender-picker input-form-calender">
                          <Form.Control placeholder="Select End Date"
                            autoComplete='off'
                            type="text"
                            id="endDate"
                            name='endDate'
                            value={endDate}
                            readOnly
                            // ref={this.openingDateRef}
                            onClick={() => this.openCalendar(2)}
                          />
                          {endDate != "" &&
                          <div className="icon">
                              <svg onClick={() => this.closeCalendar(1)} xmlns="http://www.w3.org/2000/svg" width="10" height="10" viewBox="0 0 10 10" fill="none">
                                <path d="M1 1L9 9M1 9L9 1" stroke="#84888C" stroke-width="2"/>
                              </svg>
                            </div>
                          }
                          {this.state.endCalendarOpened
                            ?
                            <OutsideClickHandler
                              onOutsideClick={this.calenderHide}
                            >
                              <div className="calender startDate">
                                <Calendar
                                  calendarType={"US"}
                                  onChange={(e) => this.changestartDate(e, 2)}
                                  value={
                                    endDate
                                      ? moment(endDate)?.format(
                                        "MM/DD/YYYY"
                                      ) === "Invalid date"
                                        ? ""
                                        : new Date(endDate)
                                      : ""
                                  }
                                  minDate={startDate ? moment(startDate).add(1, 'days').toDate() : ""}
                                />
                              </div>
                            </OutsideClickHandler>
                            : null}
                        </div>
                      </div>
                      <div className="form-item">
                        <div className="item-label">
                        <Form.Label>Assigned To</Form.Label>
                        </div>
                          <div className={`dropdown-interface`}>
                          {this.state.assignToList.length > 0 && (
                            <SingleSearchDropdownList
                              showIcon={true}
                              isRefresh={this.state.isRefresh}
                              itemList={this.state.assignToList}
                              handleSelectedItem={this.handleSelectedItem.bind(
                                this,
                                3
                              )}
                              defaultItem={this.state.assignToList}
                              defaultText={"Assigned To"}
                              // defaultName={this.state.assignToList.filter((item) => item.id === this.state.assignedTo)[0]?.name}
                              defaultName={(this.state.assignToList.filter((item) => item.id == this.state.assignedTo))[0]?.name == undefined ? "Select a technician" :
                                (this.state.assignToList.filter((item) => item.id == this.state.assignedTo))[0]?.name}
                              
                              controlID="3"
                            />
                            )}
                          </div>
                        </div>
                    </div>
                    {/* PROCEDURES SECTION */}
                    <div className="section-wrapper pb-3 mb-3 mt-4">
                      <div className="d-flex justify-content-between align-items-center mb-2">
                        <div className="btnwrapper">
                          <button
                            className="btn p-0"
                            onClick={() => this.setState({ showProcedures: !this.state.showProcedures })}
                          >
                            {this.state.showProcedures ? 
                            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M6.29297 10.707L12 16.414L17.707 10.707L16.293 9.293L12 13.586L7.70697 9.293L6.29297 10.707Z" fill="#1D1E20" />
                          </svg>
                           : 
                           <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                              <path d="M6.29297 10.707L12 16.414L17.707 10.707L16.293 9.293L12 13.586L7.70697 9.293L6.29297 10.707Z" fill="#1D1E20" transform="rotate(-90 12 12)" />
                            </svg>
                         } Procedures ({this.state.tableProceuresData.length})
                          </button>
                        </div>
                        <AddProcedure
                            ref={this.refAddProcedure}
                            conflictCheck="Actual"
                            // parentState={_.cloneDeep(this.state)}
                            parentState={this.state}
                            selectProcedureListSlideOut={this.selectProcedureListSlideOut}
                            assetTypes={this.props.assetTypes}
                            pageType="MaintenanceSchudleSlieOut"
                            scheduleDataid={this.state.scheduleData[0]?.id}
                            tableProceuresData={this.state.tableProceuresData}
                            // tableProceuresDataSlideOut={this.state.tableProceuresData}
                            // procedureSelection={this.procedureSelection}
                            // disabled={!createEditPermission}
                          // multiSelectErrorValidation={this.multiSelectErrorValidation}
                          alignRight={true}
                          />
                      </div>
                      {this.state.showProcedures && (
                        <div className="">
                          <BootstrapTable
                            //id={"procuers"}
                            // {...props.baseProps}
                            keyField="ID"
                            data={sortedProcedureData}
                            columns={columns}
                            rowEvents={tableRowEvents}
                          // hover
                          // selectRow={selectRow}
                          /> 
                        </div>
                      )}
                    </div>

                    {/* LOCATIONS SECTION */}
                    <div className="section-wrapper">
                      <div className="d-flex justify-content-between align-items-center mb-2">
                        <div className="btnwrapper">
                          <button
                            className="btn p-0"
                            onClick={() => this.setState({ showLocations: !this.state.showLocations })}
                          >
                            {this.state.showLocations ? 
                            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M6.29297 10.707L12 16.414L17.707 10.707L16.293 9.293L12 13.586L7.70697 9.293L6.29297 10.707Z" fill="#1D1E20" />
                          </svg>
                           : 
                           <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                              <path d="M6.29297 10.707L12 16.414L17.707 10.707L16.293 9.293L12 13.586L7.70697 9.293L6.29297 10.707Z" fill="#1D1E20" transform="rotate(-90 12 12)" />
                            </svg>
                            } Locations ({this.state.locationControl.length})
                          </button>
                        </div>
                        <LocationAdded
                          ref={this.refLocationAdded}
                        //   conflictCheck="Actual"
                            parentState={this.state}
                            // locationAdded={this.locationAdded}
                            selectLocationList={this.selectLocationList}
                            disabled={this.props.disabled}
                            pageType="MaintenanceSchudleSlieOut"
                            scrollToDropDown={this.scrollToDropDown}
                            alignRight={true}

                            
                          // multiSelectErrorValidation={this.multiSelectErrorValidation}
                        />
                      </div>

                      {this.state.showLocations && (
                        <div className="">
                         <BootstrapTable
                            //id={"procuers"}
                            // {...props.baseProps}
                            keyField="ID"
                            data={this.state.locationControl}
                            columns={columns2}
                            // rowEvents={tableRowEvents}
                          // hover
                          // selectRow={selectRow}
                          /> 
                        </div>
                      )}
                    </div>
                </div>
                  <div>
                    <div>
                      {this.state.isChanges && description != "" && !this.state.isFormNotValid && (
                        <div className="strip-wrapper">
                          <div className="fixed-action">
                            <div className="d-flex align-items-center flex-wrap forecast-action-strip">
                              <h4 className="message mr-auto p-0 m-0 mr-auto h-auto">You have unsaved changes. Would you like to save and continue?</h4>
                              <Button
                                onClick={() => { this.onDiscardChanges(this.state.isNew ? "Cancel":"Discard") }}
                                className="btn-discard"
                              > Discard</Button>
                              <Button className="skip-btn"
                                onClick={this.isOnsavemaintenance}
                              >Save Changes</Button>
                            </div>
                          </div>
                        </div>

                      )}
                  </div>
                </div>
                {/* {
                  this.state.isProcedureMaintenanceSlideout &&
                   <ProcedureMaintenanceSlideOut 
                   parentState={this.state}
                   closeProcedureSlideout={this.closeProcedureSlideout} />
                } */}

              </Container>
            </div>
          </div>
        </div>

        {/* </OutsideClickHandler> */}

      </>
    );
  }

}